import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-left-corner",
  "use": "icon-left-corner-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-left-corner\"><path d=\"M962 62v900H62A900 900 0 0 0 961.55 90.125L962 62z\" p-id=\"1037\" data-spm-anchor-id=\"a313x.manage_type_myprojects.0.i0.77743a815yQGXK\" class=\"\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol